import React from 'react';


export const StatusIndicator = ({ text }) => (
  <div className={`item-field item-${text.toLowerCase().replace('| ', '').replace(' ', '-')}`}>
    <span>{text}</span>
  </div>
);
